import vue from 'vue'
import FormArea from './FormArea'
import FormInput from './FormInput'
import FormSelect from './FormSelect'
import FormRadio from './FormRadio'
import FormSwitch from './FormSwitch'
import FormCheckbox from './FormCheckbox'
import FormTextarea from './FormTextarea'
import FormPassword from './FormPassword'
import FormCreditCard from './FormCreditCard'
import FormCreditExpire from './FormCreditExpire'
import FormLabel from './FormLabel'
import FormSlider from './FormSlider'
import FormBirthtime from './FormBirthtime'
import FormBirthtimeSimple from './FormBirthtimeSimple'
import FormPalmInput from './FormPalmInput'
import FormBirthday from './FormBirthday'
import FormFile from './FormFile'
import FormDate from './FormDate'
import FormTime from './FormTime'
import FormSecurityCode from './FormSecurityCode'

const utvStoreForm = {
  install(Vue, options) {
    Vue.component('form-area', FormArea)
    Vue.component('form-input', FormInput)
    Vue.component('form-select', FormSelect)
    Vue.component('form-radio', FormRadio)
    Vue.component('form-radio', FormRadio)
    Vue.component('form-switch', FormSwitch)
    Vue.component('form-checkbox', FormCheckbox)
    Vue.component('form-textarea', FormTextarea)
    Vue.component('form-radio', FormRadio)
    Vue.component('form-password', FormPassword)
    Vue.component('form-label', FormLabel)
    Vue.component('form-credit-card', FormCreditCard)
    Vue.component('form-credit-expire', FormCreditExpire)
    Vue.component('form-slider', FormSlider)
    Vue.component('form-birthtime', FormBirthtime)
    Vue.component('form-birthtime-simple', FormBirthtimeSimple)
    Vue.component('form-palm-input', FormPalmInput)
    Vue.component('form-birthday', FormBirthday)
    Vue.component('form-file', FormFile)
    Vue.component('form-time', FormTime)
    Vue.component('form-date', FormDate)
    Vue.component('form-security-code', FormSecurityCode)
  }
}

export default utvStoreForm



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/forms/index.js